import { styled } from '@zenbusiness/zui/styles';

export const FieldContainerStyle = ({ theme }) => ({
  padding: '16px 24px',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: theme.palette.background.grey.light
});

export const FieldContainerStyled = styled('div')(FieldContainerStyle);
